// ──────────────────────────
// Gate that waits for Clerk Auth to finish restoring the user.
// • Shows your animated Loading screen while auth is initialising.
// • Renders protected children when a user is present.
// • Falls back to the route you supply when no user is signed-in.

import {
  ClerkLoaded,
  ClerkLoading,
  SignedIn,
  SignedOut,
  useAuth,
} from "@clerk/clerk-react";

const AuthGate = ({ children, fallback }) => {
  const { userId } = useAuth();

  window.__authGatePing = {
    t: Date.now(),
    path: window.location.pathname,
  };

  // If we already have a userId, render children directly without waiting for ClerkLoaded
  // This prevents flickering when navigating between pages while authenticated
  if (userId) {
    return children;
  }

  return (
    <>
      <ClerkLoading>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
          Loading your session…
        </div>
      </ClerkLoading>
      <ClerkLoaded>
        <SignedIn>{children}</SignedIn>
        <SignedOut>{fallback}</SignedOut>
      </ClerkLoaded>
    </>
  );
};

export default AuthGate;
